import script from "./EventsSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsSlide.vue?vue&type=script&setup=true&lang=js"

import "./EventsSlide.vue?vue&type=style&index=0&id=19f6a1ef&lang=css"

const __exports__ = script;

export default __exports__